import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Reject_Lottie from "../../../animation/Reject_Lottie/Reject_Lottie";

const Contact_Reject_Modal = (props) => {
  const navigate = useNavigate();

  // useEffect(() => {
  //     setTimeout(() => {
  //         // navigate("/")
  //     }, 3000);
  // }, [props])

  return (
    <section className="Contact_Success_Modal">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Contact_Success_Modal modal-holder"
      >
        <Modal.Body>
          <div className="main_container">
            <div className="lottie_holder_div">
              <Reject_Lottie />
            </div>

            <p className="title">{props?.title}</p>
            <p className="subtext">{props?.subtitle}</p>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Contact_Reject_Modal;
